/* istanbul ignore file */
import { EnumDropdown } from 'framework/form';
import React from 'react';
import { RECONCILIATION_STATUS } from 'domain/finance/costAccounting/reconcilation/useReconciliationService';

const ReconciliationStatusDropdown = (props: any) => {
  return <EnumDropdown placeholder="Choose Status" options={RECONCILIATION_STATUS} {...props} />;
};

export default ReconciliationStatusDropdown;
